interface IPageLimit {
  page?: number;
  limit?: number;
  skip?: number;
};

export {
  IPageLimit
};
